import React, { FC, useEffect } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { PatientItem } from '../../ListItems/PatientItem'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { handleAnalysisInfoModal, handleDefaultTemplateSheetModal, handleOrderInfoModal, handleTemplateSheetModal } from '../../../features/modals/modalsSlice'
import { ModalContentProps } from '../../Modal'
import { HeartIcon, LogoLongIcon,CollapseIndicatorDown, CollapseIndicatorUp, TemplateSheet } from '../../../icons'
import { YellowButton } from '../../YellowButton'
import { OrderCard } from '../../OrderCard'
import { DocumentItem } from '../../ListItems/DocumentItem'
import Skeleton from 'react-loading-skeleton'
import { addToCart, CartItemType, removeProduct } from '../../../features/cart/cartSlice'
import { resetProductInfo } from '../../../features/current-data/currentData'
import { useNavigate } from 'react-router-dom'
import { BlueButton } from '../../BlueButton'
import { Collapse, CollapseProps } from 'antd'
import useTheme from '../../../hooks/useAppColor'
import ReactMarkdown, { Components } from 'react-markdown'


export const ProductModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const getTheme = useTheme()

    const { productInfo, loadings } = useAppSelector(state => state.currentData)
    const cartProducts = useAppSelector(state => state.cart.items)
    const isInCart = cartProducts.some(item => item.id === productInfo.id)
    const {prepare} = useAppSelector(state => state.categories)
    const preparationText = prepare.find((item: any) => item.id === productInfo.prepare[0])?.text;
    const toCart = () => {
        navigate("/order/cart")
        if (handleModal) {
            handleModal()
        }

    }

    const components: Components = {
    h1: ({ node, ...props }) => (
      <h1 className={`${getTheme("c-dark", "c-white")} fz-l`} style={{ color: '#2c3e50', borderBottom: '2px solid #3498db' }} {...props} />
    ),
    h2: ({ node, ...props }) => (
      <h2 className={`${getTheme("c-dark", "c-white")} fz-l`} style={{ color: '#34495e', paddingLeft: '10px' }} {...props} />
    ),
    p: ({ node, ...props }) => (
      <p className={`${getTheme("c-dark", "c-white")} fz-l`} style={{ lineHeight: '1.6', marginBottom: '1em'}} {...props} />
    ),
    a: ({ node, ...props }) => (
      <a 
        style={{ color: '#e74c3c', textDecoration: 'none' }} 
        target="_blank" 
        rel="noopener noreferrer" 
        {...props} 
      />
    ),
  };

    const items: CollapseProps['items'] = [{
        key: '1',
        label: <h2 className={ `${getTheme("c-dark", "c-white")} fz-l`}>Описание</h2>,
       children: productInfo.info ? (
        <ReactMarkdown components={components}>
            {productInfo.info}
        </ReactMarkdown>
        ) : 
        (
        <span className={`${getTheme("c-dark", "c-white")} fz-l`}>
            Описание отсутствует.
        </span>
        )
    }, {
        key: '2',
        label: <h2 className={ `${getTheme("c-dark", "c-white")} fz-l`}>Подготовка к анализу</h2>,
        children: preparationText ? (
            <ReactMarkdown components={components}>
                {preparationText}
            </ReactMarkdown>
        ) : (
        <span className={`${getTheme("c-dark", "c-white")} fz-l`}>
            Описание отсутствует.
        </span>
        )}
    ]

    const addProduct = () => {
        dispatch(addToCart({ ...productInfo as CartItemType }))
    }

    const removeItem = () => {
        dispatch(removeProduct({id: productInfo.id, cost: productInfo.cost}))
    }

    useEffect(() => {
        return () => {
            dispatch(resetProductInfo())
        }
    }, [])

    useEffect(() => {
               localStorage.setItem('cartItems', JSON.stringify(cartProducts))
            },[cartProducts])

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <p className='c-dark fw-5 fz-l fw-6'>Подробнее</p>
                <div className='f-03'></div>
            </div>

            <div className="gap-35 f-column f-1">
                <div className="f-column gap-15">
                    {
                        loadings.product_info ? <Skeleton borderRadius={6} height={60} /> : <h2 className={` ${getTheme("c-dark", "c-white")}`}>
                            {productInfo.name}
                        </h2>
                    }

                </div>
                <div className={`f-column gap-15`}>
                    <Collapse items={items} bordered={false} ghost={true} expandIconPosition='end' expandIcon={({ isActive }) => isActive ? <CollapseIndicatorUp  width={15} height={15} /> : <CollapseIndicatorDown width={15} height={15} />} />
                    {/* { 
                        loadings.product_info ? <Skeleton borderRadius={6} height={100} /> : <p className="text c-lg fz-m">
                            {productInfo.info || "Описание отсутствует."}
                        </p>
                    } */}

                </div>

            </div>
            <div className="f-row-betw gap-10">
                {
                    !isInCart ? <YellowButton className='f-c-row gap-10' onClick={addProduct}>
                        + Добавить в корзину

                    </YellowButton> :
                        <>
                            <YellowButton className='f-c-row gap-10' onClick={toCart}>
                                В корзине
                                <div className="countYellowWhite fz-s">{cartProducts.length}</div>
                            </YellowButton>
                            <BlueButton className='f-c-row gap-10' onClick={removeItem}>
                                - Убрать
                            </BlueButton>
                        </>
                }

            </div>
        </BorderedPageLayout>
    )
}
